import React from "react";
//#region types
import { Grid } from "@mui/material";
//#endregion
//#region components
import { EntityTitleProps } from "models/propTypes/commonPropTypes";
import { Skeleton } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const EntityTitle: React.FC<EntityTitleProps> = (props) => {
  const { status, subTitle, title, loading } = props;
  return (
    <Grid container direction="column" className={cssExports.entityTitleContainer}>
      {status !== undefined ? (
        <Grid item className={cssExports.statusLabelContainer}>
          {<div className={cssExports.statusLabel}>{!loading ? status : <Skeleton width="10ch" />}</div>}
        </Grid>
      ) : (
        <> </>
      )}
      <Grid item className={cssExports.subTitle}>
        {loading && !subTitle ? <Skeleton width="14ch" /> : subTitle}
      </Grid>
      <Grid item className={cssExports.title}>
        {loading && !title ? <Skeleton width="8ch" /> : title}
      </Grid>
    </Grid>
  );
};

export default EntityTitle;
